import { db, User } from "../utils/db";

const SELF_ID = 1;

export const DEFAULT_GOALS = {
  kcal: 2200, // kcal
  fat: 73, // g->kcal 1:9
  carbs: 220, // g->kcal 1:3.75
  proteins: 165, // g->kcal 1:4
};

// Add a user
export async function addUser(user: Omit<User, "id">) {
  return db.users.add({ ...user });
}

// Get all users
export async function getAllUsers() {
  return db.users.toArray();
}

// Get user by id
export async function getUser(id: string) {
  return db.users.get(id);
}

// Update user
export async function updateUser(id: string, updates: Partial<User>) {
  return db.users.update(id, updates);
}

// Delete user
export async function deleteUser(id: string) {
  return db.users.delete(id);
}

export async function getSelf() {
  const self = await db.users.get(SELF_ID.toString());
  if (self?.id) {
    return self;
  }

  await db.users.add({
    id: SELF_ID.toString(),
    firstName: "Self",
    lastName: "Self",
    gender: "m",
    bornDate: "2000-01-01",
    weight: 75,
    height: 180,
    activityLevel: "moderate",
    email: "test@example.com",
    phone: "+31612345678",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  });

  return db.users.get(SELF_ID.toString());
}

export async function updateSelf(updates: Partial<User>) {
  return db.users.update(SELF_ID.toString(), updates);
}
